import { Button, Divider } from "antd"
import { useHistory } from "react-router-dom"
import AuthLayout from "views/auth-views/components/auth-layout"

interface Props {
}

export function EmailConfirmationRequiredPage(props: Props) {
  const history = useHistory()

  return (
    <AuthLayout>
      <h3>
        Email Confirmation Required
      </h3>
      <p>
        Please check your email and click the confirmation link to continue the registration.
      </p>

      <Divider>
        <span className="text-muted font-size-base font-weight-normal">or </span>
      </Divider>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >

        <Button
          onClick={() => history.push('/')}
        >
          Go back to Timenotes
        </Button>

      </div>
 
    </AuthLayout>
  )

}